const COOKIE_SEARCH_HISTORY: string = 'search_history';

export const SEARCH_COOKIE = {
    searchHistory: COOKIE_SEARCH_HISTORY,
};
